<z-modal [open]="open" [autoClose]="false" [autoWidth]="true" (openChange)="dismiss()">
    <ng-container body>
        <div class="flex flex-row items-stretch gap-10 -my-10">
            <div class="flex flex-col justify-center gap-5 max-w-sm -mt-5">
                <span
                    class="bg-zen-riverGreen bg-opacity-10 text-zen-riverGreen rounded-full px-3 py-1.5 text-xs font-semibold self-start uppercase tracking-wide flex flex-row items-center gap-1.5">
                    <svg class="h-3 w-3 flex-shrink-0" viewBox="0 0 16 16" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 0L9.8 6.2L16 8L9.8 9.8L8 16L6.2 9.8L0 8L6.2 6.2L8 0Z" />
                    </svg>
                    {{ 'airLaunchBadge' | translate:language:ModuleNames.Announcements }}
                </span>

                <h2 class="text-zen text-4xl font-bold leading-tight">
                    {{ 'cultureLaunchTitle' | translate:language:ModuleNames.Announcements }}
                </h2>

                <p class="text-zen-lite text-base leading-relaxed">
                    {{ 'cultureLaunchDesc' | translate:language:ModuleNames.Announcements }}
                </p>

                <div class="flex flex-col gap-3 mt-2">
                    <div *ngFor="let point of points; let i = index" class="flex flex-row items-center gap-3">
                        <!-- bg-zen-blueWhite is 245/248/251 — invisible on the card. -->
                        <span
                            class="bg-zen-blue bg-opacity-10 text-zen-blue rounded-full h-7 w-7 flex-shrink-0 flex items-center justify-center text-sm font-semibold">
                            {{ i + 1 }}
                        </span>
                        <span class="text-zen-lite text-sm">
                            {{ point | translate:language:ModuleNames.Announcements }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Bleeds to the card edge: -mt-20 clears the body's py-10 plus the card's
                 own py-10, -mr-10 the body's px-10, -mb-10 down to the footer. -->
            <img [src]="image" alt="" class="w-96 self-stretch object-cover object-center -me-10" [ngClass]="(language | language) ? 'rounded-tl' : 'rounded-tr'" />
        </div>
    </ng-container>

    <ng-container footer>
        <div class="flex flex-row items-center justify-end gap-3 w-full">
            <!-- <a zenButton [styles]="'ghost height-11'" class="!text-exp !font-medium">
                {{ 'airLaunchExplain' | translate:language:ModuleNames.Announcements }}
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a> -->

            <a zenButton [styles]="'ghost height-11'" (click)="dismiss()">
                {{ 'airLaunchMaybeLater' | translate:language:ModuleNames.Announcements }}
            </a>
            <div class="flex-1"></div>
            <a zenButton [styles]="'exp height-11'" class="!font-medium" (click)="explore()">
                {{ 'cultureLaunchCta' | translate:language:ModuleNames.Announcements }}
            </a>
        </div>
    </ng-container>
</z-modal>